import Vue from 'vue';
import { JSONParser } from '@/utils/JSONParser';
import { SelectOptions } from '@/components/Controls/Select/types';
import { CatalogSortSelectProps } from '@/components/CatalogSortSelect/types';
import CatalogSortSelect from '@/components/CatalogSortSelect/CatalogSortSelect.vue';
import { RootElementAttrsHolder } from '@/plugins/RootElementAttrsPlugin';

export function createCatalogToolbarWidget(el: Element) {
    const parser = new JSONParser('createCatalogToolbarWidget');
    const rootAttrs = new RootElementAttrsHolder(el);

    const srtOptions = el.getAttribute('data-srt-options');
    const srt = el.getAttribute('data-srt');
    const metrix = el.getAttribute('data-metrix');

    const props: CatalogSortSelectProps = {
        srtOptions: parser.parse<SelectOptions>(srtOptions),
        srt: parser.parse<number>(srt),
        metrix: parser.parse<unknown>(metrix),
    };

    return new Vue({
        el,
        name: 'CatalogToolbarWidget',
        rootAttrs,
        render: (h) => h(CatalogSortSelect, { props }),
    });
}
